import { BaseEntity } from './base-entity';
export class MenuItemView extends BaseEntity {
    constructor(){
        super();
    }

    Name: string = null;
    Url: string = null;
    Icon: string = null;
    HrAfter: boolean = null;
    HasSubMenu: boolean = null;
    SubMenu: MenuItemView[];
    Expanded: boolean;
    Loading: boolean;
    IsEnabled: boolean;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Name = input.Name;
        this.Url = input.Url;
        this.Icon = input.Icon;
        this.HrAfter = input.HrAfter;
        this.HasSubMenu = input.HasSubMenu;
        this.SubMenu = [];
        this.Loading = false;
        this.IsEnabled = input.IsEnabled;

        return this;
    }
}